import { render, staticRenderFns } from "./ManageFindings.vue?vue&type=template&id=0b16d76a&"
import script from "./ManageFindings.vue?vue&type=script&lang=js&"
export * from "./ManageFindings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports